const prefix = "TMP-";

/**
 * Saves data in localStorage with TTL
 * @param key key to store the data
 * @param value data to store
 * @param ttlMs time to live in milliseconds
 */
function setLocalStorageWithExpiry<T>(
  key: string,
  value: T,
  ttlMs: number
): void {
  key = prefix + key;
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttlMs,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

/**
 * Recover temporal data on the localStorage
 * @param key key used to store the data
 * @returns data saved or null if it is expired or not exists
 */
function getLocalStorageWithExpiry<T>(key: string): T | null {
  key = prefix + key;
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (error) {
    console.error(error);
  }
  return null;
}

/**
 * removes a entry
 * @param key key to delete
 */
function removeLocalStorageWithExpiry(key: string): void {
  key = prefix + key;
  localStorage.removeItem(key);
}

export {
  setLocalStorageWithExpiry,
  getLocalStorageWithExpiry,
  removeLocalStorageWithExpiry,
};
